import { Col, Row } from 'antd';
import styles from './index.module.less';
import { useConfigProvider } from '@/context/ConfigProvider';
import { imgUrl } from '@/shared/utils';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

const BookItem = ({ contentData }: { contentData?: any }) => {
  const { t } = useTranslation();
  const { isMobile } = useConfigProvider();

  return (
    <div className={styles.bookContainer}>
      <Row>
        <Col>
          <Image
            src={imgUrl(contentData?.book?.image_url, 'mid')}
            width={isMobile ? 150 : 216}
            height={isMobile ? 226 : 324}
            alt={contentData?.book?.book_name}
            loading="lazy"
          />
        </Col>
        <Col className={styles.bookContent}>
          <div className={styles.title}>{contentData?.book?.book_name}</div>
          <div className={styles.titleContent}>
            {/* <span className={styles.rightTitle}>{`by ${contentData?.book?.author} (Author)`} </span> */}
            <span className={styles.rightTitle}>{t('byAuthor').replace('xxx', contentData?.book?.author)} </span>
          </div>
          <div className={styles.titleContent} style={{ marginTop: 20 }}>
            <span className={styles.leftTitle}>{t('genres')}:</span>
          </div>
          {(contentData?.book?.tags ?? []).map((item: any, index: number) => {
            return (
              <div className={styles.titleContent} key={index}>
                <span className={styles.rightTitle}>{item}</span>
              </div>
            );
          })}
        </Col>
      </Row>
    </div>
  );
};

export default BookItem;
